import { render } from "./PopularTrainerComponent.vue?vue&type=template&id=40224abc&scoped=true"
import script from "./PopularTrainerComponent.vue?vue&type=script&lang=js"
export * from "./PopularTrainerComponent.vue?vue&type=script&lang=js"

import "./PopularTrainerComponent.vue?vue&type=style&index=0&id=40224abc&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40224abc"]])

export default __exports__